/** 표시 형식·입력 해석 (숫자, 금액, 날짜, 개인정보 마스킹) */
const nf = new Map();
function numFmt(dec) {
    let f = nf.get(dec);
    if (!f) {
        f = new Intl.NumberFormat('ko-KR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        nf.set(dec, f);
    }
    return f;
}
export function formatNumber(v, decimals) {
    if (decimals == null) {
        // 소수 자릿수를 값에 맞춰 (최대 4자리) — 검사 결과값 표시용
        const s = String(v);
        const d = s.includes('.') ? Math.min(4, s.length - s.indexOf('.') - 1) : 0;
        return numFmt(d).format(v);
    }
    return numFmt(decimals).format(v);
}
/** "20261009", "2026-10-09", "2026.10.09", "2026/10/9", "1009"(올해), "t"/"오늘" → 날짜 문자열 */
export function parseDate(text, out = 'YYYY-MM-DD') {
    const t = text.trim();
    if (!t)
        return null;
    let y, m, d;
    const now = new Date();
    if (/^(t|today|오늘)$/i.test(t)) {
        y = now.getFullYear();
        m = now.getMonth() + 1;
        d = now.getDate();
    }
    else {
        const digits = t.replace(/[^\d]/g, '');
        const parts = t.split(/[^\d]+/).filter(Boolean);
        if (parts.length === 3) {
            y = +parts[0];
            m = +parts[1];
            d = +parts[2];
            if (y < 100)
                y += 2000;
        }
        else if (digits.length === 8) {
            y = +digits.slice(0, 4);
            m = +digits.slice(4, 6);
            d = +digits.slice(6, 8);
        }
        else if (digits.length === 6) {
            y = 2000 + +digits.slice(0, 2);
            m = +digits.slice(2, 4);
            d = +digits.slice(4, 6);
        }
        else if (digits.length === 4) {
            y = now.getFullYear();
            m = +digits.slice(0, 2);
            d = +digits.slice(2, 4);
        }
        else
            return null;
    }
    const dt = new Date(y, m - 1, d);
    if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d)
        return null;
    const p = (n) => String(n).padStart(2, '0');
    return out === 'YYYYMMDD' ? `${y}${p(m)}${p(d)}` : `${y}-${p(m)}-${p(d)}`;
}
/** 저장 형식과 무관하게 화면에는 YYYY-MM-DD 로 */
export function displayDate(v) {
    if (!v)
        return '';
    if (/^\d{8}$/.test(v))
        return `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)}`;
    return v.length > 10 && v[10] === 'T' ? v.slice(0, 10) : v;
}
export function displayDateTime(v) {
    if (!v)
        return '';
    if (/^\d{12,14}$/.test(v))
        return `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)} ${v.slice(8, 10)}:${v.slice(10, 12)}`;
    return v.replace('T', ' ').slice(0, 16);
}
export function maskPrivacy(v, kind) {
    if (!v)
        return '';
    if (kind === 'rrn') {
        const d = v.replace(/\D/g, '');
        return d.length >= 7 ? `${d.slice(0, 6)}-${d[6]}******` : v;
    }
    if (kind === 'phone') {
        const d = v.replace(/\D/g, '');
        return d.length >= 10 ? `${d.slice(0, 3)}-****-${d.slice(-4)}` : v;
    }
    if (kind === 'name')
        return v.length <= 1 ? v : v.length === 2 ? v[0] + '*' : v[0] + '*'.repeat(v.length - 2) + v[v.length - 1];
    return v;
}
